import { render, staticRenderFns } from "./TabsWhatsApp.vue?vue&type=template&id=6c755088"
import script from "./TabsWhatsApp.vue?vue&type=script&lang=js"
export * from "./TabsWhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports